import React from 'react';
import { FadeIn } from './FadeIn';
import { MoonIcon } from 'lucide-react';
export function HookSection() {
  return <section className="py-16 px-6 bg-white/50" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <div className="flex justify-center mb-6" data-id="element-108">
            <MoonIcon className="w-8 h-8 text-lavender" data-id="element-109" />
          </div>
          <p className="text-xl sm:text-2xl font-serif text-taupe text-center italic leading-relaxed mb-8" data-id="element-110">
            "Son las 3:00 AM. Estás caminando por el pasillo, meciendo a tu bebé
            por tercera vez esta noche. Tus ojos arden, tu espalda duele y lo
            único que deseas es cerrar los ojos y saber que él también
            descansará."
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-111">
          <div className="bg-sage/10 rounded-2xl p-6 sm:p-8 text-center" data-id="element-112">
            <p className="text-lg text-taupe font-medium" data-id="element-113">
              No eres una mala madre por sentirte agotada. Simplemente estás
              luchando contra la biología de tu bebé en lugar de trabajar con
              ella.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}